document.addEventListener('DOMContentLoaded', () => {
    const ucScript = document.getElementById("usercentrics-cmp") as HTMLScriptElement | null;

    if (ucScript) {
        if (window.__ucCmp) {
            void initCrossDomainLinks();
        } else {
            ucScript.addEventListener("load", () => {
                void initCrossDomainLinks();
            });
        }
    }
});

async function initCrossDomainLinks(): Promise<void> {
    if (!window.__ucCmp || typeof window.__ucCmp.getControllerId !== 'function') {
        return;
    }

    const controllerId = await window.__ucCmp.getControllerId() as string;
    const crossDomainLinks = document.querySelectorAll<HTMLAnchorElement>('a[data-cross-domain]');

    for (const crossDomainLink of crossDomainLinks) {
        const originalUrl: string = crossDomainLink.href;
        const targetUrl = new URL(originalUrl, window.location.origin);

        if (targetUrl.hostname !== window.location.hostname) {
            targetUrl.searchParams.set('usercentrics-controller-id', controllerId);
            crossDomainLink.href = targetUrl.toString();
        }
    }
}
